export default __webpack_public_path__ + "static/media/aff_Filter.c969e1a8.svg";